import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CareersCTABand() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-brand-700 via-brand-600 to-secondary-700">
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Ccircle cx='40' cy='40' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      <div ref={ref} className={`container-page relative z-10 scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-paper-50 mb-4">
            Ready to Build?
          </h2>
          <p className="text-brand-100/80 max-w-xl mx-auto mb-8 text-sm md:text-base">
            We&apos;re changing how frozen food moves across India — and we&apos;re looking for people who want to be part of building something that hasn&apos;t existed before.
          </p>
          <a
            href="mailto:careers@freshhlock.com"
            className="inline-block px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            Send Us Your Resume
          </a>
        </div>
      </div>
    </section>
  );
}